<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  headerType: { type: String, default: 'none' },
  headerText: { type: String, default: '' },
  headerImage: { type: String, default: '' },
  body: { type: String, default: '' },
  footer: { type: String, default: '' },
  buttons: { type: Array, default: () => [] },
});

const { t } = useI18n();

const visibleButtons = computed(() =>
  props.buttons.filter(button => String(button?.text || '').trim())
);

const iconClass = type => {
  const kind = String(type || '').toUpperCase();
  if (kind === 'URL') return 'i-lucide-external-link';
  if (kind === 'PHONE_NUMBER') return 'i-lucide-phone';
  return 'i-lucide-reply';
};
</script>

<template>
  <aside class="flex flex-col gap-3">
    <p class="text-sm font-medium text-n-slate-12">
      {{ t('CAMPAIGN.WHATSAPP.WORKSPACE.PREVIEW') }}
    </p>
    <div class="overflow-hidden rounded-lg bg-n-slate-4">
      <img
        v-if="headerType === 'image' && headerImage"
        :src="headerImage"
        :alt="t('CAMPAIGN.WHATSAPP.WORKSPACE.HEADER_IMAGE')"
        class="object-cover w-full max-h-48"
      />
      <div class="flex flex-col gap-1 px-3 py-3">
        <p
          v-if="headerType === 'text' && headerText"
          class="text-sm font-medium text-n-slate-12"
        >
          {{ headerText }}
        </p>
        <p class="text-sm whitespace-pre-wrap text-n-slate-12">
          {{ body || t('CAMPAIGN.WHATSAPP.WORKSPACE.PREVIEW_EMPTY') }}
        </p>
        <p v-if="footer" class="text-xs text-n-slate-11">
          {{ footer }}
        </p>
      </div>
      <div
        v-if="visibleButtons.length"
        class="border-t divide-y divide-n-weak border-n-weak"
      >
        <div
          v-for="(button, index) in visibleButtons"
          :key="index"
          class="flex items-center justify-center gap-2 px-3 py-2.5 text-sm font-medium text-n-teal-11"
        >
          <span class="size-4" :class="iconClass(button.type)" />
          <span>{{ button.text }}</span>
        </div>
      </div>
    </div>
  </aside>
</template>
